import { useNavigate } from "react-router-dom";
import Header from './include/header';
import Footer from './include/footer';
import Slider from './pages/slider';
import Services from './pages/services';
import Management from './pages/management';
import Connect from './pages/connect';
import Value from './pages/value';
import Vision from './pages/vision';
import Testimonials from './pages/testimonials';
import ManagementServices from './pages/management-services';
import FinancialManagement from './pages/financial';
import Communities from './pages/communities';
import Helpful from './pages/helpful'

const App = () => {

  const navigate = useNavigate();
  const handleScroll = (elementDiv: any) => {
    const element = document.getElementById(elementDiv);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // 'auto' for instant scroll
    }
    navigate(`/${elementDiv}`);
  };

  return (
    <div className="App">
      <Header />
      <Slider />
      <Services />
      <Management />
      <Connect />
      <Value />
      <Vision />
      <Testimonials />
      <ManagementServices />
      <FinancialManagement />
      <Communities />
      <Helpful />
      <Footer />
      <div className="d-web-block">
        <button onClick={() => {
          handleScroll("contact-us");
        }} className="quote-button">
          REQUEST A QUOTE
          <img
            src="assets/img/Vector-2.png"
            className="ms-2"
            width={20}
            height={20}
            alt=""
          />
        </button>
      </div>
      <div className="d-mob-block">
        <button onClick={() => {
          handleScroll("contact-us");
        }} className="quote-button">
          <img
            src="assets/img/Vector-2.png"
            width={20}
            height={20}
            alt=""
          />
        </button>
      </div>
    </div>
  );
}

export default App;
